export const navigationLinks = {
  services: [
    {
      title: "PV-Anlagen",
      href: "/info/solar-anlagen-pv-information",
      description:
        "Erfahre mehr über die Möglichkeiten von Photovoltaik für dein Zuhause.",
    },
    {
      title: "Wärmepumpen",
      href: "/info/waermepumpe-information",
      description: "Mit Wärmepumpen kannst du Heizkosten senken. Erfahre mehr.",
    },
    {
      title: "Ladestationen",
      href: "/info/ladestation-elektroauto-plug-in-hybrid-wallbox",
      description:
        "Wir bieten Ladestationen für dein Elektroauto an. Erfahre mehr.",
    },
  ],
  b2c: [
    {
      title: "Warum vind?",
      description: "Erfahre mehr über uns und unsere Leistungen",
      href: "/fuer-hausbesitzer/warum-vind",
    },
    {
      title: "Solaranlage",
      description: "Strom sparen mit einer Solaranlage",
      href: "/fuer-hausbesitzer/solaranlage",
    },
    {
      title: "Wärmepumpe",
      description: "Heizkosten senken mit einer Wärmepumpe",
      href: "/fuer-hausbesitzer/waermepumpe",
    },
    {
      title: "Ladestation",
      description: "Ladestationen für Elektroautos",
      href: "/fuer-hausbesitzer/ladestation",
    },
    {
      title: "FAQ",
      description: "Häufig gestellte Fragen",
      href: "/fuer-hausbesitzer/faq",
    },
    {
      title: "Kontakt",
      description: "Nimm Kontakt mit uns auf",
      href: "/kontakt",
    },
    {
      title: "Karriere",
      description: "Karriere bei vind",
      href: "/jobs",
    },
  ],
  b2b: [
    {
      title: "Warum vind?",
      description: "Erfahren Sie mehr über uns und unsere Leistungen",
      href: "/fuer-unternehmen/warum-vind",
    },
    {
      title: "Solaranlage",
      description: "Gewinne steigern mit einer Solaranlage",
      href: "/fuer-unternehmen/solaranlage",
    },
    {
      title: "Ladestationen",
      description: "Für Mitarbeiter und Kunden",
      href: "/fuer-unternehmen/ladestation",
    },
    {
      title: "FAQ",
      description: "Häufig gestellte Fragen",
      href: "/fuer-unternehmen/faq",
    },
    {
      title: "Kontakt",
      description: "Kontaktieren Sie uns",
      href: "/kontakt",
    },
  ],
  partners: [
    {
      title: "Vertriebspartner",
      description: "Werden Sie Vertriebspartner",
      href: "/fuer-partner/vertriebspartner",
    },
    {
      title: "Installation DC",
      description: "Werden Sie Partner für die DC-Installation",
      href: "/fuer-partner/installation-dc",
    },
    {
      title: "Installation AC",
      description: "Werden Sie Partner für die AC-Installation",
      href: "/fuer-partner/installation-ac",
    },
    {
      title: "FAQ",
      description: "Häufig gestellte Fragen",
      href: "/fuer-partner/faq",
    },
    {
      title: "Kontakt",
      description: "Kontaktieren Sie uns",
      href: "/kontakt",
    },
  ],
  shop: [
    {
      title: "Kategorien",
      href: "/shop",
      description: "Durchstöbere unser Sortiment und finde, was du brauchst.",
    },
    {
      title: "Alle Produkte",
      href: "/shop/alle-produkte",
      description:
        "Sieh dir alle unsere Produkte an einem Ort an. Finde schnell, was du brauchst.",
    },
  ],
};

export const navigation = [
  {
    title: "Informationen",
    children: navigationLinks.b2c,
    href: "/fuer-hausbesitzer/solaranlage",
  },
  {
    title: "Shop",
    children: navigationLinks.shop,
    href: "/shop",
  },
  {
    title: "Ratgeber",
    children: [
      {
        title: "Energieratgeber 2025",
        description:
          "Unser neuer Energieratgeber berät dich über die Energie in deinem Haushalt",
        href: "/ratgeber",
      },
      {
        title: "Energiekosten senken",
        href: "/ratgeber/energiekosten-senken",
        description: "Klare Tipps, wie du deine Energiekosten senken kannst",
      },
    ],
    href: "/ratgeber",
  },
];

export const partnerNavigation = [
  {
    title: "Informationen",
    children: navigationLinks.b2c,
    href: "/fuer-hausbesitzer/solaranlage",
  },
  {
    title: "Ratgeber",
    children: [
      {
        title: "Energieratgeber 2025",
        description:
          "Unser neuer Energieratgeber berät dich über die Energie in deinem Haushalt",
        href: "/ratgeber",
      },
      {
        title: "Energiekosten senken",
        href: "/ratgeber/energiekosten-senken",
        description: "Klare Tipps, wie du deine Energiekosten senken kannst",
      },
    ],
    href: "/ratgeber",
  },
  {
    title: "Partner Portal",
    href: "/partners",
  },
];
